import { useState, useEffect } from 'react';

import { localizationService } from '../../services/localization.js';

import { Modal } from '../Modal/Modal.js'

import classNames from 'classnames';

import styles from './Products.module.css';

export const Products = ({ data }) => {
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [data]);

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.header}>{localizationService.currentLang$.value === 'EN' ? data?.type : data?.arType}</h1>
      <div
        className={classNames(styles.cardsWrapper, {
          [styles.kitchens]: data?.type === 'Kitchens',
          [styles.security]: data?.type === 'Security Doors',
          [styles.steelWork]: data?.type === 'Steel Work',
          [styles.bedrooms]: data?.type === 'Bedrooms',
        })}
      >
        {data?.assets?.map(item => <div className={styles.card} key={item.id} style={{backgroundImage: `url(${item.img})`}} onClick={() => setModalData(item)}></div>)}
      </div>
      {!!modalData && <Modal data={modalData} setModalData={setModalData}/>}
    </div>
  )
}
